import { Badge, Group, Text } from "@mantine/core";
import RankingTrendIcon from "@/components/ranking-trend-icon";

const RankingByMoedasBadge = ({ desafio }: { desafio: TDesafio }) => {
  if (!desafio.rankingByMoedas) {
    return null;
  }

  return (
    <Group align="center" gap="xs">
      <Badge
        color="gray.2"
        py="md"
        px="sm"
        radius="md"
        style={{ minHeight: "32px", display: "flex", alignItems: "center" }}
        leftSection={<RankingTrendIcon ranking={desafio.rankingByMoedas} />}
      >
        <Text c="dark" fz="xs" fw={500} tt="lowercase" style={{ lineHeight: 1.4 }}>
          {desafio.rankingByMoedas.ranking}&#9900; no Ranking
        </Text>
      </Badge>
    </Group>
  );
};

export default RankingByMoedasBadge;
